/*** IMPORTS FROM imports-loader ***/
var define = false;

export function mobileNav() {
  var hamburger = document.querySelector('.hamburger');
  var body = document.querySelector('body');

  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('is-active');
    if (body.classList.contains('navOpen')) {
      body.classList.remove('navOpen');
    } else {
      body.classList.add('navOpen');
    }
  });

  // Close nav on mobile click
  $('.mainNav__listItem, .navDrawer .button').on('click tap', function() {
    hamburger.classList.toggle('is-active');
    if (body.classList.contains('navOpen')) {
      body.classList.remove('navOpen');
    } else {
      body.classList.add('navOpen');
    }
  });
}
